const defaultTextTemplate = {
  id: '',
  x: 0,
  y: 0,
  width: 1000,
  height: 500,
  w2pText: {
    text: '',
    textAlign: 'left',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontFamily: 'Roboto',
    fontSize: 116.676,
    fontSizePT: 22,
    colorName: 'Pure White',
    color: [255, 255, 255], // must be one of valid pantone color values
  },
  isSelected: false,
  isInArea: true,
  disableInput: true, // NOTE: prevents internal text editor from appearing on double click
  disableResize: true,
  rotation: 0,
  backgroundImage: '',
  backgroundColor: [0, 0, 0, 0],
};

const defaultTextTemplateV2 = {
  id: '',
  x: 0,
  y: 0,
  width: 1000,
  height: 500,
  w2pText: {
    text: '',
    textAlign: 'left',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontFamily: 'Roboto',
    fontSize: 116.676,
    fontSizePT: 22,
    colorName: 'Pure Black',
    color: [0, 0, 0], // must be one of valid pantone color values
  },
  isSelected: false,
  isInArea: true,
  disableInput: true, // NOTE: prevents internal text editor from appearing on double click
  disableResize: true,
  rotation: 0,
  backgroundImage: '',
  backgroundColor: [0, 0, 0, 0],
};

export { defaultTextTemplate, defaultTextTemplateV2 };
